var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "./Routes.constants.js";
class Util {
  constructor() {
    __publicField(this, "_modulePath", ROUTES.isolationGroup.root.match.path);
    __publicField(this, "_modulePathname", ROUTES.isolationGroup.root.location.pathname);
    __publicField(this, "routes", {
      root: {
        path: () => `${this.path}`,
        url: () => `${this.url}`
      },
      create: {
        path: () => `${ROUTES.isolationGroup.create.match.path}`,
        url: () => {
          return `${this.url}${ROUTES.isolationGroup.create.location.pathname}`;
        }
      },
      list: {
        path: () => `${ROUTES.isolationGroup.list.match.path}`,
        url: (pivot) => {
          return `${this.url}${ROUTES.isolationGroup.list.location.pathname}${pivot ? `/${pivot}` : ""}`;
        }
      },
      view: {
        path: () => `${ROUTES.isolationGroup.view.match.path}`,
        url: (isolationGroupId) => `${this.url}${ROUTES.isolationGroup.view.location.pathname}/${isolationGroupId}`
      }
    });
  }
  /**
   * React Router regex path
   */
  get path() {
    return `${NavigationService.root.path}${this._modulePath}`;
  }
  /**
   * Pathname used to construct complete URL
   */
  get url() {
    return `${NavigationService.root.url}${this._modulePathname}`;
  }
}
const IsolationGroupRouteUtils = new Util();
export {
  IsolationGroupRouteUtils
};
//# sourceMappingURL=IsolationGroupRoute.utils.js.map
